export const roadmap = [
  {
    id: "released",
    title: "Released",
    status: "released",
    color: "#22c55e",
    description:
      "Available today and actively supported.",

    products: [
      {
        name: "Magyne Master",
        eta: "Available Now",
        features: [
          "Multi-tenant Architecture",
          "Centralized Authentication",
          "Business Registration",
          "Role-based Access Control",
          "Secure Tenant Isolation",
          "Business Management Portal"
        ]
      },
      {
        name: "Magyne Carwash Pro",
        eta: "Available Now",
        features: [
          "Customer Management",
          "Vehicle Management",
          "Job Cards",
          "POS & Payments",
          "Invoices & Receipts",
          "Rewards Program",
          "Business Reports"
        ]
      },
      {
        name: "Magyne School (K-12)",
        eta: "Available Now",
        features: [
          "Admissions",
          "Student Information",
          "Attendance",
          "Teacher Management",
          "Subjects",
          "Examinations",
          "Report Cards",
          "Billing & Payments",
          "Parent Portal"
        ]
      }
    ]
  },

  {
    id: "progress",
    title: "In Progress",
    status: "progress",
    color: "#3b82f6",
    description:
      "Currently under active development.",

    products: [
      {
        name: "Magyne Campus",
        eta: "Q4 2026",
        features: [
          "Student Admissions",
          "Student Information System",
          "Course & Programme Management",
          "Semester & Academic Calendar",
          "Course Registration",
          "Timetable Management",
          "Examinations & Transcripts",
          "Results & GPA Calculation",
          "Fees & Online Payments",
          "Student Portal",
          "Lecturer Portal",
          "Learning Management Integration",
          "Library Integration",
          "Hostel & Accommodation",
          "Research & Publications"
        ]
      }
    ]
  },

  {
    id: "planned",
    title: "Planned",
    status: "planned",
    color: "#f59e0b",
    description:
      "Scheduled for development.",

    products: [
      {
        name: "Magyne Medic",
        eta: "2027",
        features: [
          "Electronic Medical Records",
          "Appointments",
          "Laboratory",
          "Pharmacy",
          "Billing",
          "Insurance"
        ]
      },
      {
        name: "Magyne POS",
        eta: "2027",
        features: [
          "Retail POS",
          "Inventory",
          "Barcode Scanning",
          "Suppliers",
          "Sales Analytics"
        ]
      },
      {
        name: "Magyne HR",
        eta: "2027",
        features: [
          "Employee Records",
          "Payroll",
          "Leave Management",
          "Recruitment",
          "Performance Reviews"
        ]
      }
    ]
  },

  {
    id: "future",
    title: "Future",
    status: "future",
    color: "#94a3b8",
    description: "Ideas we're researching for future releases.",

    products: [
      { name: "Magyne Hotels" },
      { name: "Magyne Properties" },
      { name: "Magyne Manufacturing ERP" },
      { name: "Magyne CRM" }
    ]
  }
];